import React from 'react'
import { SidebarLayout } from '@/components/SidebarLayout'
import { RenderBlocks, type Block } from '@/blocks/RenderBlocks'

export type SidebarLayoutBlockProps = {
  main?: Block[] | null
  sidebar?: Block[] | null
  side?: 'left' | 'right' | null
  blockType: 'sidebarLayout'
}

export const SidebarLayoutBlock: React.FC<SidebarLayoutBlockProps> = ({ main, sidebar, side }) => {
  const sidebarSlot = sidebar && sidebar.length > 0 ? <RenderBlocks blocks={sidebar} /> : undefined
  return (
    <SidebarLayout
      main={<RenderBlocks blocks={main ?? []} />}
      sidebar={sidebarSlot}
      side={side || undefined}
    />
  )
}
